<span [formGroup]="this.form">
  <input *ngIf="this.isActive" class="finance-input"
    [style.width]="this.setDynamicWidth(this.form.value[this.controlName])"
    [style.border-color]="this.form.controls[this.controlName].invalid ? 'red' : 'black'"
    type="number"
    step="0.01"
    [formControlName]="this.controlName"
  />
</span>
